import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "@/store";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

Vue.config.productionTip = false;

Vue.filter("mileage", function (value: number) {
  return new Intl.NumberFormat("de", {useGrouping: true}).format(value) + " km";
});

Vue.filter("format", function (value: number, unit: string, fractionDigits: number) {
  return new Intl.NumberFormat("de", {useGrouping: true, maximumFractionDigits: fractionDigits}).format(value) + " " + unit;
});

Vue.filter("eur", function (value: number, fraction: number) {
  return new Intl.NumberFormat("de", {style:"currency", currency: "EUR", maximumFractionDigits: fraction}).format(value);
});

Vue.filter("signed", function (value: string) {
  if (value.charAt(0) === "-") {
    return value;
  }
  return "+" + value;
});

Vue.filter("date", function (value: Date) {
  return value.toLocaleDateString("de");
});

const configOptions = {
  apiKey: "AIzaSyAy9a8poysN8tbVr-oBjmtKJZmvnswfcyw",
  authDomain: "gasboard.firebaseapp.com",
  databaseURL: "https://gasboard.firebaseio.com",
  projectId: "gasboard",
  storageBucket: "",
  messagingSenderId: "",
  appId: ""
};

firebase.initializeApp(configOptions);

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    user.getIdToken(true).then(function(idToken) {
      store.commit("login", user);
      if (router.currentRoute.name !== "home")
        router.push("/");
    });
  } else {
    store.commit("logout");
    if (router.currentRoute.name !== "login")
      router.push("/login");
  }
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
